import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Modal } from '@dds-uicore/all';
@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.css']
})
export class InfoModalComponent implements OnInit,AfterViewInit {
  @ViewChild('triggerContainer') triggerContainer: ElementRef<HTMLElement>;
  @Input() modalId: string;
  @Input() modalTitleId: string;
  constructor() { }
  ngAfterViewInit(): void {
    const content = this.triggerContainer.nativeElement;
    if (content) {
      // If the modal-trigger ngcontent is plain text then we want to work with the contentContainer.
        // If otherwise modal-trigger ngcontent has one or more tags we want to work with the first child of contentContainer.
        const actualContent = (content.children) ? content.children[0] : content;
      // This two attributes are needed by @dds-uicore Modal
      actualContent.setAttribute('data-toggle', 'dds__modal');
      actualContent.setAttribute('data-target', `#${this.modalId}`);
      const thisModal = new Modal(actualContent);
    }
  }

  ngOnInit(): void {
    this.modalId = `${this.modalId}-modal-${this.Uuid()}`;
    this.modalTitleId = `${this.modalTitleId}-modal-${this.Uuid()}`;
  }
  Uuid() {
    const windowObj: any = window;
    const winCrypto = windowObj.crypto || windowObj.msCrypto;
    let index = winCrypto.getRandomValues(new Uint32Array(1))[0];
    index = +`${index}`.substr(0, 1);
    const uuid = winCrypto.getRandomValues(new Uint32Array(10))[index];
    return uuid;
  }

}
